import { render, staticRenderFns } from "./patron.vue?vue&type=template&id=3bdcf116&"
import script from "./patron.vue?vue&type=script&lang=js&"
export * from "./patron.vue?vue&type=script&lang=js&"
import style0 from "./patron.vue?vue&type=style&index=0&id=3bdcf116&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports